import React from 'react'

// Ported from the source project's src/components/site/Testimonials.tsx. Per-card Reveal
// dropped, same precedent as Services.jsx/Process.jsx/Portal.jsx (the page wraps the whole
// section in one Reveal instead). The source's `id="contact"` is dropped: nothing styles or
// scrolls to it, and this app already has a distinct /contant route, so keeping it would be
// a misleading duplicate rather than useful.
//
// `t.rating` does not exist on src/content/site.js's testimonials (the seed never carried a
// per-review numeric rating), so this defaults to 5 - matching the old testimonials.jsx,
// which hardcoded a fixed 5-star row ("aria-label='5 out of 5'") for every review too.
const Testimonials = ({ section, testimonials }) => {
    return (
        <section className="section">
            <div className="container">
                <div className="section-eyebrow">{section.eyebrow}</div>
                <h2 className="section-title">{section.title}</h2>
                <div className="testimonials-grid">
                    {testimonials.map((t) => (
                        <div className="testimonial-card" key={t.order}>
                            <div className="stars">{'★'.repeat(Math.max(0, Math.min(5, t.rating ?? 5)))}</div>
                            <p className="testimonial-text">&ldquo;{t.quote}&rdquo;</p>
                            <div className="testimonial-author">
                                <div className="author-avatar">{t.initials}</div>
                                <div>
                                    <div className="author-name">{t.authorName}</div>
                                    <div className="author-role">{t.authorRole}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
